import elliotPic from "@/public/images/artists/elliot.jpg";
import { Artist } from "@/types/types";

export const elliot = {
  id: "293",
  name: "Elliot",
  image: elliotPic,
  description: `Elliot has a bright, emotive voice with smooth tone, expressive vibrato, and a dynamic, heartfelt delivery.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Felliot-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Soul", "Belting"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 50,
        high: 68,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
